import SectionTitle from "@/components/ui/section-title";
import useQueryOrganizations from "@/hooks/queries/useQueryOrganizations";
import { Box } from "@mui/material";
import React from "react";
import { Styled } from "./styles";
import { useSelect } from "./hooks";
import Organization from "./organization";
import { i18n } from "@/utils/i18n";

const Organizations: React.FC = () => {
    const { data: organizations } = useQueryOrganizations();
    const { onSelect, selectedOrg } = useSelect();

    return (
        <Box padding="40px">
            <SectionTitle title={i18n.t("yourMunicipalities")} />
            <Styled.List>
                {Object.entries(organizations ?? {}).map(i => {
                    const oid = i[0];
                    const isSelected = oid === selectedOrg;

                    return (
                        <Organization
                            key={oid}
                            isSelected={isSelected}
                            onSelect={onSelect}
                            data={i}
                        />
                    );
                })}
            </Styled.List>
        </Box>
    );
};

export default Organizations;
